import {normalizeApiError} from './normalizeApiError';

/** RTK `queryFn` result shape: a successful `data` or a normalized `error`. */
export type ClientQueryResult<T> = {data: T} | {error: unknown};

export const clientQuery =
  <Args, Result>(call: (args: Args) => Promise<Result>) =>
  async (args: Args): Promise<ClientQueryResult<Result>> => {
    try {
      return {data: await call(args)};
    } catch (error) {
      return {error: normalizeApiError(error)};
    }
  };

// For endpoints typed `<void, Args>` whose client call returns a value that is
// intentionally discarded (e.g. delete/revoke). Returns `{data: undefined}`.
export const voidClientQuery =
  <Args>(call: (args: Args) => Promise<unknown>) =>
  async (args: Args): Promise<ClientQueryResult<undefined>> => {
    try {
      await call(args);
      return {data: undefined};
    } catch (error) {
      return {error: normalizeApiError(error)};
    }
  };
